import React, { useState, useEffect, useRef } from 'react';
import { Button, Container, Row, Col, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { referralActions, planActions } from '../../actions';
import moment from 'moment-jalaali'
import DatePicker from 'react-datepicker2';

import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import PageTitle from "../../components/common/PageTitle";
import date from '../../utils/date'

const ReferralsList = () => {
    const { SearchBar } = Search;
    const { _referralId } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    // const user = useSelector(state => state.authentication.user);
    const loading = useSelector(state => state.referral.status);
    const referral = useSelector(state => state.referral.referral);
    const referralCode = useSelector(state => state.referral.referral.codes);
    const plans = useSelector(state => state.plan.plans);
    const [referralCodes, setReferralCodes] = useState([]);
    const [plansDetails, setPlansDetails] = useState();
    const [show, setShow] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [editCode, setEditCode] = useState();
    const [initialValues, setInitialValues] = useState()
    const isGregorian = true;

    useEffect(() => {
        dispatch(referralActions.findReferral(_referralId));
        dispatch(planActions.getAll());
        setStartDate(moment());
        // alert(moment('2020/01/01').toISOString())
    }, [])

    useEffect(() => {
        if (!referralCode || !plansDetails) return;
        setReferralCodes(referralCode)
    }, [referralCode, plansDetails])

    useEffect(() => {
        if (plans.length < 1) return
        let plansList = {}
        const sortedPlans = _.sortBy(plans, ['interval', 'intervalCount']);
        sortedPlans.map(plan => {
            if (!plan.amount) {
                const intervalNumber = plan.interval === 'day' ? 1 : (plan.interval === 'month' ? 2 : 3)
                const intervalCount = plan.intervalCount > 9 ? plan.intervalCount : `0${plan.intervalCount}`
                plansList = {
                    ...plansList,
                    [plan._id]: {
                        key: parseInt(`${intervalNumber}${intervalCount}`),
                        name: `${plan.intervalCount} ${_.capitalize(plan.interval)}`,
                        id: plan._id,
                        currency: plan.currency,
                        intervalCount: plan.intervalCount,
                        amount: plan.amount,
                        interval: plan.interval
                    }
                }
            }
        })
        setPlansDetails(plansList);
    }, [plans])

    useEffect(() => {
        if (!editCode && show) {
            formik.values.code = ''
            formik.values.plan = ''
            formik.values.valid = true
            formik.values.maxUse = ''
            setStartDate(moment());
            setEndDate();
        }
    }, [show])

    const handleClose = () => {
        // document.getElementById('form').reset();
        setShow(false);
        setEditCode();
    };
    const handleShow = () => {
        setShow(true);
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: _.get(editCode, '_id', ''),
            code: _.get(editCode, 'code', ''),
            plan: _.get(editCode, 'plan', ''),
            valid: _.get(editCode, 'valid', true),
            maxUse: _.get(editCode, 'maxUse', ''),
        },
        onSubmit: values => {
            values = {
                ...values,
                startDate: moment(startDate).toISOString(),
                endDate: endDate ? moment(endDate).toISOString() : '',
            }
            if (!values.endDate) delete values.endDate
            if (!values.maxUse) delete values.maxUse
            if (!editCode) {
                dispatch(referralActions.addCode(_referralId, { ...values }));
            } else {
                dispatch(referralActions.updateCode(_referralId, { ...values }));
            }
            handleClose();
        },

    });

    const handleCreate = () => {

    };

    const handleUpdate = () => {

    };

    const columns = [
        {
            text: 'Code',
            dataField: 'code',
        },
        {
            text: 'Validation',
            dataField: 'valid',
            formatter: validFormatter,
        },
        {
            text: 'Plan',
            dataField: 'plan',
            formatter: planFormatter,
        },
        {
            text: 'Used',
            dataField: 'timesUsed',
            formatter: usedFormatter,
        },
        {
            text: 'Start Date',
            dataField: 'startDate',
            formatter: dateFormatter,
        },
        {
            text: 'End Date',
            dataField: 'endDate',
            formatter: dateFormatter,
        },
        {
            text: 'Action',
            dataField: '_id',
            formatter: actionFormatter,
        }
    ]

    function planFormatter(cell, row) {
        const plan = plansDetails[cell];
        return plan.name;
    }
    function validFormatter(cell, row) {
        return cell ? (<span className="success">Valid</span>) : (<span className="danger">Invalid</span>);
    }
    function usedFormatter(cell, row) {
        return `${cell}/${row.maxUse ? row.maxUse : '∞'}`;
    }
    function dateFormatter(cell, row) {
        if (cell) {
            return date(cell)
        } else {
            return '∞'
        }
    }
    function actionFormatter(cell, row) {
        return (
            <div className="tableTempActionBox">
                {/* <Button className="tableTempAction" theme="info" onClick={() => detailsHandler(cell)}><i className="material-icons">info</i> Details</Button> */}
                <Button className="tableTempAction" onClick={() => editHandler(row)}><i className="material-icons">edit</i> Edit</Button>
                {/* <Button className="tableTempAction" theme="danger"><i className="material-icons">delete</i> Delete</Button> */}
            </div>
        )
    }

    const detailsHandler = (referralId) => {
        history.push(`referral/${referralId}`);
    }

    const editHandler = (code) => {
        setEditCode(code);
        setStartDate(moment(date(_.get(code, 'startDate')), 'YYYY/MM/DD'))
        setEndDate(moment(date(_.get(code, 'endDate')), 'YYYY/MM/DD'))
        handleShow();
    }

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            Showing { from} to { to} of { size} Results
        </span>
    );

    const options = {
        paginationTotalRenderer: customTotal,
        showTotal: true,
        onSizePerPageChange: (sizePerPage, page) => {
            // console.log('Size per page change!!!');
            // console.log('Newest size per page:' + sizePerPage);
            // console.log('Newest page:' + page);
        },
        onPageChange: (page, sizePerPage) => {
            // console.log('Page change!!!');
            // console.log('Newest size per page:' + sizePerPage);
            // console.log('Newest page:' + page);
        }
    };

    return (
        <Container fluid className={`main-content-container px-4 ${loading === 'loading' && 'blur'}`}>
            {/* Page Header */}
            <Row noGutters className="page-header py-4">
                <PageTitle sm="4" title={_.get(referral, 'name')} subtitle="Accounting / Referral Details" className="text-sm-left" />
                <Col className="headerButtonHolder">
                    <Button type="submit" variant="success" onClick={handleShow}><i className="material-icons"></i> Add New Code</Button>
                    <Button className="" variant="danger" onClick={() => history.push(`/referrals`)}><i className="material-icons"></i> Back</Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ToolkitProvider
                        keyField="_id"
                        data={referralCodes}
                        columns={columns}
                        search
                    >
                        {
                            props => (
                                <div>
                                    <SearchBar {...props.searchProps} />
                                    <hr />
                                    <BootstrapTable
                                        {...props.baseProps}
                                        pagination={paginationFactory(options)}
                                    />
                                </div>
                            )
                        }
                    </ToolkitProvider>
                </Col>
            </Row>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{`${editCode ? 'Edit Referral Code' : 'New Referral Code'}`}</Modal.Title>
                </Modal.Header>
                <form id="form" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <span>Code:</span>
                                <input id="code" name="code" disabled={editCode} value={formik.values.code} onChange={formik.handleChange} />
                            </Col>
                            <Col>
                                <span>Plan:</span>
                                <select id="plan" name="plan" disabled={editCode} value={formik.values.plan} onChange={formik.handleChange}>
                                    <option value="" hidden>---</option>
                                    {plansDetails && Object.entries(plansDetails).map(([id, data]) =>
                                        <option value={id} key={id}>{`${data.name} Free`}</option>
                                    )}
                                </select>
                            </Col>
                            <Col>
                                <span>Validation:</span>
                                <select id="valid" name="valid" value={formik.values.valid} onChange={formik.handleChange}>
                                    <option value={true} >Valid</option>
                                    <option value={false} >Invalid</option>
                                </select>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span>Max Use:</span>
                                <input id="maxUse" name="maxUse" value={formik.values.maxUse} onChange={formik.handleChange} />
                            </Col>
                            <Col>
                                <span>Start Date:</span>
                                <DatePicker
                                    id="startDate"
                                    name="startDate"
                                    disabled={editCode}
                                    timePicker={false}
                                    // value={formik.values.startDate}
                                    // onChange={formik.handleChange}
                                    onChange={value => setStartDate(value)}
                                    value={startDate}
                                    min={moment().subtract(1, 'days')}
                                    // setTodayOnBlur={false}
                                    isGregorian={isGregorian}
                                    inputFormat="YYYY/MM/DD"
                                    inputJalaaliFormat="jYYYY/jMM/jDD"
                                />
                                {/* <input id="startDate" name="startDate" /> */}

                            </Col>
                            <Col>
                                <span>End Date:</span>
                                <DatePicker
                                    name="endDate"
                                    timePicker={false}
                                    min={moment(startDate)}
                                    value={endDate}
                                    onChange={value => setEndDate(value)}
                                    isGregorian={isGregorian}
                                    setTodayOnBlur={false}
                                    inputFormat="YYYY/MM/DD"
                                    inputJalaaliFormat="jYYYY/jMM/jDD"
                                />
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleClose}>Cancel</Button>
                        <Button type="submit" variant="primary">{editCode ? `Update` : `Add`}</Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </Container >
    );
}

export default ReferralsList;
